export default __webpack_public_path__ + "static/media/1907.711d6077.png";